module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": true
    },
    on: {
      "close": _vm.closeModalLocal
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.unit) ? _c('div', {}) : _vm._e()])]), _vm._v(" "), (_vm.unit) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "h1"
  }, [_c('h1', [_vm._v(_vm._s((_vm.unit.display_name || _vm.unit.description_title)))])]), _vm._v(" "), _c('div', {
    staticClass: "special-periods"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n        Specialveckor\n      ")]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "title-row"
  }, [_c('th', [_c('b', [_vm._v("Helg")])]), _vm._v(" "), _c('th', [_vm._v("\n            Datum\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Pris\n          ")])]), _vm._v(" "), _vm._l((_vm.unit.prices_special), function(price, index) {
    return _c('tr', [_c('td', [_c('b', {
      domProps: {
        "innerHTML": _vm._s(price.title)
      }
    })]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(price.days)
      }
    }), _vm._v(" "), _c('td', [(price.period.free) ? _c('span', {
      class: {
        price: true, selected: (_vm.cartAccomodationObject && _vm.cartAccomodationObject.period && (_vm.cartAccomodationObject.unitLid == _vm.unit.unit_lid && _vm.cartAccomodationObject.poolLid == _vm.unit.pool_lid) && _vm.cartAccomodationObject.period.period == price.period.period && _vm.cartAccomodationObject.period.week == price.period.week)
      },
      on: {
        "click": function($event) {
          _vm.chooseAccomodation({
            pool_lid: _vm.unit.pool_lid,
            unit_lid: _vm.unit.unit_lid,
            period: price.period,
            week: price.period.week,
            name: (_vm.unit.display_name || _vm.unit.description_title),
            capacity: _vm.unit.capacity,
            price: price.period.price
          })
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm._f("currency")(price.period.price)) + "\n            ")]) : _vm._e(), _vm._v(" "), (!price.period.free) ? _c('span', {
      staticClass: "taken"
    }, [_vm._v("\n              uthyrd\n            ")]) : _vm._e()])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "normal-periods"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n        PRISÖVERSIKT\n      ")]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "title-row"
  }, [_c('th', [_vm._v(" ")]), _vm._v(" "), _vm._l((_vm.meta_super_titles), function(meta, index) {
    return _c('th', {
      staticClass: "period-super-title",
      attrs: {
        "colspan": _vm.meta_periods.length / _vm.meta_super_titles.length
      }
    }, [_vm._v("\n            " + _vm._s(meta) + "\n          ")])
  })], 2), _vm._v(" "), _c('tr', {
    staticClass: "title-row"
  }, [_c('th', {
    staticClass: "week-indicator"
  }, [_c('b', [_vm._v("Vecka")])]), _vm._v(" "), _vm._l((_vm.meta_periods), function(period) {
    return _c('th', {
      staticClass: "week-day-title"
    }, [_vm._v("\n            " + _vm._s(period.days) + "\n          ")])
  })], 2), _vm._v(" "), _vm._l((_vm.unit.prices), function(week, index) {
    return (index >= _vm.meta_weeks[0] && index <= _vm.meta_weeks[1]) ? _c('tr', [_c('td', {
      staticClass: "week-indicator",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('b', [_vm._v("v." + _vm._s(week.week))]), _vm._v(" "), _c('popper', {
      attrs: {
        "trigger": "click",
        "options": {
          placement: 'right'
        }
      }
    }, [_c('div', {
      staticClass: "popper"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.showDates(week.periods))
      }
    })]), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_vm._v("\n                Datum\n              ")])])], 1), _vm._v(" "), _vm._l((week.periods), function(period) {
      return _c('td', [(period && period.free) ? _c('span', {
        class: {
          price: true, selected: (_vm.cartAccomodationObject && _vm.cartAccomodationObject.period && (_vm.cartAccomodationObject.unitLid == _vm.unit.unit_lid && _vm.cartAccomodationObject.poolLid == _vm.unit.pool_lid) && _vm.cartAccomodationObject.period.period == period.period && _vm.cartAccomodationObject.period.week == period.week)
        },
        on: {
          "click": function($event) {
            _vm.chooseAccomodation({
              pool_lid: _vm.unit.pool_lid,
              unit_lid: _vm.unit.unit_lid,
              period: period,
              week: week.week,
              name: (_vm.unit.display_name || _vm.unit.description_title),
              capacity: _vm.unit.capacity,
              price: period.price
            })
          }
        }
      }, [_vm._v("\n              " + _vm._s(_vm._f("currency")(period.price)) + "\n            ")]) : _vm._e(), _vm._v(" "), (period && !period.free) ? _c('span', {
        staticClass: "taken"
      }, [_vm._v("\n              uthyrd\n            ")]) : _vm._e()])
    })], 2) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "margin-top": "15px"
    }
  }), _vm._v(" "), (!_vm.loaded) ? _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Tillgängligheten uppdaterades senast " + _vm._s(_vm._f("fromNow")(_vm.meta_updated)) + "... De laddas nu om, var god vänta...")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (false) ? _c('pre', [_vm._v(_vm._s(_vm.unit))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fdb0d55"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/deprecated/UnitPriceModal.vue
// module id = 950
// module chunks = 0